import 'dayjs/locale/es';
import 'dayjs/plugin/duration';

import SessionIcon from '../../../app/assets/icons/session.svg?react';
import { useThemeContext } from '../../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../../Translations/providers/TranslationsContextProvider';
import { Column } from '../../../app/components/Column/Column';
import { Button } from '../../../app/components/Button/Button';
import { useIsMobile } from '../../../app/hooks/useIsMobile';
import { SheetModal } from '../../../app/components/SheetModal/SheetModal';
import { Modal } from '../../../app/components/Modal/Modal';
import { SheetModalHeader } from '../../../app/components/SheetModal/SheetModalHeader';
import { useMediaContext } from '../providers/MediaContextProvider';
import { useEffect } from 'react';

export interface PermissionsPopUpProps {
	show?: boolean;
	onClose: () => void;
}

export function PermissionsPopUp({
	show = false,
	onClose,
}: Readonly<PermissionsPopUpProps>) {
	const { t } = useTranslationsContext();
	const theme = useThemeContext();
	const { requestPermissions } = useMediaContext();
	const isMobile = useIsMobile();

	const content = () => {
		return (
			<Column $spaceBetween $fillHeight $gap={18}>
				<>
					<div dangerouslySetInnerHTML={{ __html: t('permissions.content') }}></div>
				</>
				<Button
					onClick={() => {
						requestPermissions();
					}}
					$color={'primary'}
					$block
				>
					{t('permissions.request_permissions')}
				</Button>
			</Column>
		);
	};

	useEffect(() => {
		if (!show) {
			onClose();
		}
	}, [show, onClose]);

	return (
		<>
			{isMobile && (
				<SheetModal
					isOpen={show}
					header={
						<SheetModalHeader
							prepend={
								<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />
							}
							title={t('permissions.title')}
						/>
					}>
					{content()}
				</SheetModal>
			)}
			{!isMobile && (
				<Modal
					show={show}
					closeDisabled
					title={t('permissions.title')}
					$fitToChildren={true}
					prepend={
						<SessionIcon
							fill={theme.colors.brand.primary[300]}
							width={25}
							height={25}
						></SessionIcon>
					}
				>
					{content()}
				</Modal>
			)}
		</>
	);
}
